import { getCountry } from "@trueskin-web/locales"
import { useTranslation } from "@trueskin-web/translations"

import imageAfter from "../../../../images/plan-selection/christina-after.webp"
import imageBefore from "../../../../images/plan-selection/christina-before.webp"
import TrustedShopsBadge from "../../trusted-shops-badge"
import FAQs from "../components/faqs"
import MoneyBack from "../components/money-back"
import PageHeader from "../components/page-header"
import Testimonials from "../components/testimonials"
import { faqs } from "../resources"

import Plans from "./plans/plans"
import Products from "./products"

const ChoosePlanCore = ({ presetList }) => {
  const { t } = useTranslation()

  const country = getCountry()

  return (
    <div data-testid="web-portal-plan-selection-core">
      <PageHeader
        headline={t("ChoosePlan.title")}
        sx={{
          mt: 6,
          mb: 5,
        }}
      />
      <Products />

      <Plans presetList={presetList} />

      <div
        sx={{
          display: ["block", "grid"],
          mt: 5,
          gridTemplateColumns: [null, "1fr 2fr"],
          gridColumnGap: [null, 6],
        }}
      >
        <MoneyBack />
        <Testimonials
          headline="Echte Menschen – Echte Erfolge"
          subline="Nach nur 6–8 Behandlungswochen feiern
unsere Patient:innen sichtbare Erfolge."
          images={[imageBefore, imageAfter]}
          labels={["Vorher", "Nach 2 Monaten"]}
          customer={
            <>
              <span sx={{ fontWeight: "bold" }}>Christina,</span> Akne-Patientin
              bei FORMEL SKIN
            </>
          }
        />
      </div>
      {country === "DE" && <FAQs items={faqs} />}

      <TrustedShopsBadge />
    </div>
  )
}

export default ChoosePlanCore
